const minin = {
  data() {
    return {
      baseUrl: "repair",
      form: {
        type: null,
        carid: undefined,
        license: undefined,
        articlename: undefined,
        articleid: undefined,
        maunit: undefined,
        rstarttime: undefined,
        money: undefined,
        repair: undefined,
      },
      rules: {
        type: [{ required: true, message: "请选择车辆类型", trigger: "blur" }],
        // carid: [
        //   { required: true, message: "请选择车牌号", trigger: "blur" },
        // ],
        license: [{ required: true, message: "请选择车牌号", trigger: "blur" }],
        articlename: [
          { required: true, message: "请选择维保类型", trigger: "blur" },
        ],
        maunit: [{ required: true, message: "请填写维修商", trigger: "blur" }],
        rstarttime: [
          { required: true, message: "请选择时间", trigger: "blur" },
        ],
        money: [{ required: true, message: "请填写金额", trigger: "blur" }],
      },
      formCtrl: [
        {
          label: "种类",
          keyName: "type",
          err: "请选择",
          type: "select",
          options: [
            { label: "车头", value: 1 },
            { label: "挂车", value: 2 },
          ],
        },
        {
          label: "车牌号",
          keyName: "license",
          err: "请选择车牌号",
          type: "select",
          options: [],
        },
        {
          label: "司机姓名",
          keyName: "driver",
          err: "请填写司机姓名",
          type: "text",
          disabled: true,
        },
        {
          label: "维保类型",
          keyName: "articlename",
          err: "请选择",
          type: "select",
          options: [],
        },
        {
          label: "维修商",
          keyName: "maunit",
          err: "请选择维修商",
          type: "text",
          // type: "select",
          options: [],
        },
        {
          label: "维保时间",
          keyName: "rstarttime",
          err: "请选择时间",
          type: "date",
        },
        {
          label: "维保金额(元)",
          keyName: "money",
          err: "请填写金额",
          type: "number",
        },
        {
          label: "维保票据",
          keyName: "photo",
          tips: "最多上传2张图片",
          type: "file",
          ptype: "repair",
          max: 2,
          className: "block",
        },
        {
          label: "维保照片",
          keyName: "bill",
          tips: "最多上传5张图片",
          type: "file",
          ptype: "repair",
          max: 5,
          className: "block",
        },
        {
          label: "备注",
          keyName: "repair",
          err: "请填写内容",
          type: "textarea",
          rows: "3",
          className: "block",
        },
      ],
      rejectCtrl: {
        label: "驳回原因",
        keyName: "reject_reason",
        type: "textarea",
        viewMode: true,
        className: "block",
        rows: 4,
      },
      cars: [],
      trailer: [],
      article: [],
    };
  },
  computed: {
    // 是否显示驳回按钮
    hideRejectBtn() {
      let boo = false;
      const { user_group_id } = this.user;
      const { is_status, add_group_id } = this.detail;
      if (
        // 自己改自己的单子
        (add_group_id == user_group_id &&
          // 1 车队长审核，2 机务审核，3 退回修改，4 审核通过
          // 司机
          ((user_group_id == 9 && is_status == 3) ||
            // 队长
            (user_group_id == 5 && is_status == 3) ||
            // 超管
            (user_group_id == 1 && is_status == 4))) ||
        !this.$route.fullPath.includes("?") // 添加页不展示按钮
      ) {
        boo = true;
      }
      return boo;
    },
  },
  methods: {
    setDetail() {
      if (this.detail) {
        this.form = { ...this.detail };
      }
      const { add_group_id } = this.detail;
      if (add_group_id == 13) {
        // 维修商提交
        this.formCtrl.map((v) => {
          if (v.keyName === "maunit") {
            v.disabled = true;
          }
        });
      }
      this.$forceUpdate();
      // console.log({ ...this.detail })
      // console.log({ ...this.form });
    },
    onRejectSubmit() {
      // console.log({ ...this.form });
      // console.log(this.$refs['form']);
      this.$prompt("", "驳回原因", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(({ value }) => {
          this.rejectReq(value);
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // });
        });
    },
    rejectReq(reject_reason) {
      this.loading = true;
      let url = `repair/reject`;
      const params = {
        id: this.id,
        userid: this.user.id,
        reject_reason,
      };
      this.post(
        url,
        params,
        ({ msg }) => {
          this.loading = false;
          if (msg == "success") {
            this.$message({
              type: "success",
              message: "驳回成功!",
            });
            this.$router.back();
          } else {
            this.$message({
              type: "error",
              message: msg,
            });
          }
        },
        (err) => {
          console.log(err);
          this.$message({
            type: "error",
            message: "驳回失败，请稍后重试！",
          });
        },
      );
    },
    onCheckSubmit() {
      // console.log({ ...this.form });
      // console.log(this.$refs['form']);
      this.$refs["form"].validate((valid) => {
        const boo = this.formOrtherValidate();
        // console.log(valid, boo)
        if (valid && boo) {
          this.$confirm("确认审核通过吗？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              this.checkSubmitReq();
            })
            .catch(() => {});
        } else {
          console.log("验证不通过");
          return false;
        }
      });
    },
    checkParamsPackage(params, object) {
      for (const key in object) {
        if (Object.hasOwnProperty.call(object, key)) {
          // console.log(typeof object[key])
          const value = object[key];
          if (value && typeof value === "object") {
            // console.log(key, value)
            params[key] = value.map((v) => {
              let result = v;
              if (v.response && v.response.photo) {
                result = { url: v.response.photo };
              }
              return result;
            });
          } else {
            params[key] = value;
          }
        }
      }
      let is_status = 1;
      const { user_group_id } = this.user;
      if (user_group_id == 1) {
        // 超管默认提交归档 || 机务审核后归档
        // is_status = 4
      }
      if (user_group_id == 5) {
        // 队长审核后机务审核
        is_status = 2;
      }
      if (user_group_id == 6) {
        // 机务审核后归档
        is_status = 4;
      }
      params["is_status"] = is_status;
      delete params["articlename"];
    },
    checkSubmitReq() {
      this.loading = true;
      let url = `${this.baseUrl}/${this.submitUrl}`;
      const params = {
        userid: this.user.id,
      };
      this.checkParamsPackage(params, this.form);
      if (this.id && this.mode === "edit") {
        params["id"] = this.id;
      }
      console.log(url, params);
      this.post(
        url,
        params,
        ({ msg }) => {
          if (msg === "success") {
            this.$message({
              type: "success",
              message: "提交成功!",
            });
            this.$router.back();
          } else {
            this.$message({
              type: "error",
              message: msg,
            });
          }
          this.loading = false;
        },
        (err) => {
          console.log(err);
          this.$message({
            type: "error",
            message: "提交失败，请稍后重试！",
          });
        },
      );
    },
    onSubmit() {
      // console.log({ ...this.form });
      // console.log(this.$refs['form']);
      this.$refs["form"].validate((valid) => {
        const boo = this.formOrtherValidate();
        // console.log(valid, boo)
        if (valid && boo) {
          this.$confirm("确认提交吗？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              this.submitReq();
            })
            .catch(() => {});
        } else {
          console.log("验证不通过");
          return false;
        }
      });
    },
    getKeys() {
      const formCtrl = [...this.formCtrl];
      const arr = formCtrl.map((v) => v.keyName);
      arr.push("articleid");
      arr.push("carid");
      return arr;
    },
    specialParamsPackage(params) {
      const { add_group_id, is_status } = this.detail;
      // 储存默认审核状态
      let isstatus = is_status || 1;
      const { user_group_id } = this.user;
      // console.log(add_group_id)
      if (
        (user_group_id == 1 && add_group_id == 1) ||
        (user_group_id == 6 && add_group_id == 6)
      ) {
        // 超管默认提交归档
        isstatus = 4;
      }
      if (add_group_id == 5 && user_group_id == 5) {
        // 队长创建机务审核
        isstatus = 2;
      }
      params["is_status"] = isstatus;
      delete params["articlename"];
      if (!params["articleid"]) {
        params["articleid"] = this.detail["articleid"];
      }
    },
    onChange({ key, value }) {
      console.log(key, value);
      // console.log(typeof value)
      // console.log(Number(value))
      if (key === "articlename") {
        this.$set(this.form, key, value);
        this.article.map((c) => {
          if (c.name == value) {
            this.$set(this.form, "articleid", c.id);
          }
        });
      } else if (key === "type") {
        this.$set(this.form, key, value);
        this.$set(this.form, "carid", null);
        this.$set(this.form, "license", null);
        this.formCtrl.map((c) => {
          if (c.label == "车牌号") {
            if (value === 1) {
              c.options = this.cars.map((v) => {
                return {
                  label: v.license,
                  value: v.license,
                };
              });
            } else {
              c.options = this.trailer.map((v) => {
                return {
                  label: v.license,
                  value: v.license,
                };
              });
            }
          }
        });
      } else if (key === "license") {
        this.$set(this.form, key, value);
        const { type } = this.form;
        let arr = [];
        if (type == 2) {
          arr = [...this.trailer];
        } else {
          arr = [...this.cars];
        }
        // console.log(arr)
        arr.map((c) => {
          // console.log({ ...c })
          if (value === c.license) {
            this.$set(this.form, "driver", c.driver);
            this.$set(this.form, "carid", c.id);
          }
        });
      } else {
        this.$set(this.form, key, value);
      }
      console.log("form", { ...this.form });
    },
    setOptions({ car, trailer, article, reunit }) {
      this.formCtrl.map((c) => {
        if (c.label == "车牌号") {
          c.options = car.map((v) => {
            return {
              label: v.license,
              value: v.license,
            };
          });
          if (car && car.length) {
            this.cars = car;
          }
          if (trailer && trailer.length) {
            this.trailer = trailer;
          }
          if (this.detail['type'] == 2) {
            c.options = trailer.map((v) => {
            return {
              label: v.license,
              value: v.license,
            };
          });
          }
        } else if (c.keyName == "articlename" && article && article.length) {
          this.article = [...article];
          c.options = article.map((v) => {
            return {
              label: v.name,
              value: v.name,
            };
          });
          // if (!this.form['articleid']) {
          //   this.form['articleid'] = article[0].id
          // }
        } else if (c.keyName == "maunit" && reunit && reunit.length) {
          // c.options = reunit.map(v => {
          //   return {
          //     label: v.maunit,
          //     value: v.maunit,
          //   }
          // })
        }
        // if (maunit) {
        //   this.form.articleid = maunit.articleid
        //   this.form.maunit = maunit.maunit
        // }
        this.$forceUpdate();
      });
      // console.log("form", { ...this.form });
      // console.log('formCtrl', [...this.formCtrl]);
    },
    onInput({ key, value }) {
      console.log(key, value);
      if (["maunit"].includes(key) && value) {
        this.inputSearch(key, value);
      } else if (!value) {
        this.formCtrl.map((v) => {
          if (v.keyName == "maunit") {
            v["options"] = [];
          }
        });
        this.$forceUpdate();
      }
    },
    inputSearch(key, value) {
      // console.log(id, key, value)
      let url = `${this.baseUrl}/maunit`;
      const params = {
        [key]: value,
      };
      // console.log(url, params)
      this.post(
        url,
        params,
        ({ msg, data }) => {
          if (msg === "success" && data) {
            this.formCtrl.map((v) => {
              if (v.keyName == "maunit") {
                v["options"] = data.map((v) => {
                  return {
                    label: v.maunit,
                    value: v.id,
                    data: v,
                  };
                });
              }
            });
            this.$forceUpdate();
          }
        },
        (err) => {
          console.log(err);
          this.$message({
            type: "error",
            message: "获取数据失败，请稍后重试！",
          });
        },
      );
    },
    onSelect({ key, value }) {
      // console.log(key, value)
      this.formCtrl.map((v) => {
        if (v.keyName == "maunit") {
          v["options"] = [];
        }
      });
      if (value) {
        this.$set(this.form, key, value[key]);
      }
      this.$forceUpdate();
    },
  },
  mounted() {
    if (!this.form.type) {
      this.$set(this.form, "type", 1);
    }
    this.getOptions({ userid: this.user.id });
  },
};

export default minin;
